import React from 'react'
import CenterGutterTabs from './CenterGutterTabs/CenterGutterTabs';
import './center-gutter-student-modal-2023.css'
import FamilyInfoTabCenterGutter from './FamilyInfoTabCenterGutter/FamilyInfoTabCenterGutter';
import StudentInfoTabCenterGutter from './StudentInfoTabCenterGutter/StudentInfoTabCenterGutter';
import CancellationsTabCenterGutter from './CancellationsTabCenterGutter/CancellationsTabCenterGutter';
import AvailabilityInfoTabCenterGutter from './AvailabilityInfoTabCenterGutter/AvailabilityInfoTabCenterGutter';
const CenterGutterStudentModal2023 = ({
    family,
    setFamily,
    instrumentList,
    teachers,
    cancellations,
    showMagicSchedulerButton = true,
    onOpenMagicScheduler,
}) => {
    const [tab, setTab] = React.useState('family')

    return (
        <div className="center-gutter-student-modal-2023">
            <CenterGutterTabs
                tab={tab}
                setTab={setTab}
                cancellations={cancellations}
                showMagicSchedulerButton={showMagicSchedulerButton}
                onOpenMagicScheduler={onOpenMagicScheduler}
            />
            {tab === 'family' && <FamilyInfoTabCenterGutter family={family} setFamily={setFamily} />}
            {tab === 'students' && <StudentInfoTabCenterGutter family={family} setFamily={setFamily} instrumentList={instrumentList} teachers={teachers} />}
            {tab === 'cancellations' && <CancellationsTabCenterGutter cancellations={cancellations} />}
            {tab === 'availability' && <AvailabilityInfoTabCenterGutter family={family} />}
        </div>
    )
}
export default CenterGutterStudentModal2023;
